import AddAudienceModal from './AddAudienceModal';
import AlertModal from './AlertModal';
import AddChildAccountModal from './AddChildAccountModal';
import AddUpdateCustomerUserModal from './AddUpdateCustomerUserModal';
import BulkEditEventsModal from './BulkEditEventsModal';
import ErrorModal from './ErrorModal';
import ChangePasswordAndLoginModal from './ChangePasswordAndLoginModal';
import ConfirmModal from './ConfirmModal';
import CreateClinicianModal from './CreateClinicianModal';
import CreateCustomerModal from './CreateCustomerModal';
import CreateCodingEventModal from './CreateCodingEventModal';
import CreateCodingEventQueueModal from './CreateCodingEventQueueModal';
import CreateCustomerUserModal from './CreateCustomerUserModal';
import CreateEmployeeUserModal from './CreateEmployeeUserModal';
import CreateMessageReplyModal from './CreateMessageReplyModal';
import CreateMessageModal from './CreateMessageModal';
import CustomerProfileModal from './CustomerProfileModal';
import PrintViewModal from './PrintViewModal';
import RequestPasswordResetModal from './RequestPasswordResetModal';
import TransitionCustomerAccountModal from './TransitionCustomerAccountModal';
import UpdateCustomerUserModal from './UpdateCustomerUserModal';
import WorksheetModal from './WorksheetModal';
import importPastedCodingEventsModal from './importPastedCodingEventsModal';
import UpsertEmrVendorModal from './UpsertEmrVendorModal';

const modalTypes = {
    addAudienceModal: AddAudienceModal,
    addChildAccount: AddChildAccountModal,
    addUpdateClinician: CreateClinicianModal,
    addUpdateCustomerUser: AddUpdateCustomerUserModal,
    alertModal: AlertModal,
    bulkEditEventsModal: BulkEditEventsModal,
    confirmModal: ConfirmModal,
    errorModal: ErrorModal,
    changePasswordAndLoginModal: ChangePasswordAndLoginModal,
    codingWorksheet: WorksheetModal,
    createCustomer: CreateCustomerModal,
    createCustomerEvent: CreateCodingEventModal,
    createCodingEventQueue: CreateCodingEventQueueModal,
    createCustomerUser: CreateCustomerUserModal,
    createEmployeeUser: CreateEmployeeUserModal,
    createMessageReply: CreateMessageReplyModal,
    createMessage: CreateMessageModal,
    customerProfile: CustomerProfileModal,
    importPastedCodingEvents: importPastedCodingEventsModal,
    printViewModal: PrintViewModal,
    requestPasswordReset: RequestPasswordResetModal,
    transitionCustomerAccount: TransitionCustomerAccountModal,
    updateCustomerUser: UpdateCustomerUserModal,
    upsertEmrVendor: UpsertEmrVendorModal
};

export default modalTypes